import { Form } from "@client/content/controls";
import { SINGLE_BUTTONS_STYLE } from "@client/content/controls/Form/lib";
import { getRootContainerProps, getRootContainerPropsDep } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo } from "@client/controls/Form/component";
import { FormModal } from "@client/controls/Modal/Modals";
import { type FormModalButton } from "@client/controls/Modal/Modals/Form/component";
import { withShow, withSubmit } from "@client/hocs";
import { type WithShowProps } from "@client/hocs/withShow";
import { type WithSubmitProps } from "@client/hocs/withSubmit";
import { useI18n } from "@common/hooks/i18n";
import React from "react";
import { type MemberProfile } from "../types";

export type Props = RootContainerProps &
  WithSubmitProps<MemberProfile.View.ResetPasswordParams> &
  WithShowProps & {
    fields: FormFieldInfo[];
  };

export default withShow(
  withSubmit((props: Props) => {
    const i18n = useI18n();

    const buttons = React.useMemo(
      (): FormModalButton[] => [
        (p) => (
          <ModuleButton
            {...getRootContainerProps(props)}
            onClick={p.onClick}
            isDisabled={p.isBusy}
            caption={i18n.resetPassword}
          />
        )
      ],
      getRootContainerPropsDep(props)
    );

    const submit = React.useCallback((data: MemberProfile.View.ResetPasswordParams) => {
      if (data.password !== data.confirmPassword) throw new Error(i18n.passwordsDontMatch);
      return props.submit(data);
    }, []);

    return (
      <FormModal
        buttonsStyle={SINGLE_BUTTONS_STYLE}
        buttons={buttons}
        fields={props.fields}
        Form={Form}
        formProps={getRootContainerProps(props)}
        isVisible={props.isVisible}
        isSubmitting={props.isSubmitting}
        error={props.errorMessage}
        onClose={props.onClose}
        onSubmit={submit}
        title={i18n.resetPassword}
        width={350}
      />
    );
  })
);
